
import {Component, Prop, Vue, Watch, toNative } from 'vue-facing-decorator';
import TemplateContentViewModel from '@/entities/TemplateContentViewModel';
import Common from '@/helper/Common';
import LanguageTypeEnum from '@/enums/LanguageTypeEnum';
import { LanguageViewModel } from '@/entities/LanguageViewModel';

@Component
class TemplateModalPopup extends Vue {
  @Prop() private templateContentViewModel!: TemplateContentViewModel;
  @Prop() private languageList!: LanguageViewModel[];
  private localTemplateContentViewModel: TemplateContentViewModel = TemplateContentViewModel.createEmpty();
  private localLanguageList: LanguageViewModel[] = [];
  private selectedLanguage = 0;
  private showCopiedMessage = false;
  private linkCopiedFadeoutTime = 1500;
  private showLanguageDropdown = false;


  private mounted() {
    if (this.templateContentViewModel) {
      this.localTemplateContentViewModel.Heading = this.templateContentViewModel.Heading;
      this.localTemplateContentViewModel.ModelDescription = this.templateContentViewModel.ModelDescription;
      this.localTemplateContentViewModel.PrimaryButtonText = this.templateContentViewModel.PrimaryButtonText;
      this.localTemplateContentViewModel.SecondaryButtonText = this.templateContentViewModel.SecondaryButtonText;
      this.localTemplateContentViewModel.IsPrimaryButtonVisible = this.templateContentViewModel.IsPrimaryButtonVisible;
      this.localTemplateContentViewModel.IsSecondaryButtonVisible = this.templateContentViewModel.IsSecondaryButtonVisible;
    }
    this.selectedLanguage = LanguageTypeEnum.English; // Default language
    if (this.languageList && this.languageList.length > 0) {
      this.localLanguageList = this.languageList;
      this.showLanguageDropdown = true;
    }
  }

  private TemplateLanguageChange(event: Event) {
    const languageId = parseInt((event.target as HTMLSelectElement).value, 10);
    this.selectedLanguage = languageId;
    this.$emit('language-change', languageId);
  }

  private CloseModalPopup() {
    this.$emit('close-template-modal-popup');
  }

  private GetInstructionHtml() {
    const instructionDiv = this.$refs.templateContent as HTMLElement;

    if (instructionDiv) {
      const htmlContent = instructionDiv.innerHTML;
      return htmlContent;
    }
    return null;
  }

  private async CopyContentToClipboard() {
    this.showCopiedMessage = await Common.CopyContentToClipboard(
      this.GetInstructionHtml(),
    );
    if (this.showCopiedMessage) {
      setTimeout(() => {
        this.showCopiedMessage = false;
      }, this.linkCopiedFadeoutTime);
    }
  }

  @Watch('templateContentViewModel', { deep: true })
  private onEventAccessInstructionViewModelChange(newValue: TemplateContentViewModel) {
    if (newValue) {
      this.localTemplateContentViewModel.Heading = newValue.Heading;
      this.localTemplateContentViewModel.ModelDescription = newValue.ModelDescription;
      this.localTemplateContentViewModel.PrimaryButtonText = newValue.PrimaryButtonText;
      this.localTemplateContentViewModel.SecondaryButtonText = newValue.SecondaryButtonText;
    }
  }
}

export default toNative(TemplateModalPopup);
